export enum RegepProcessStatus {
  RequestSent = 1,
  EngineeringRequestUpdated = 2,
  EngineeringOpenIssue = 3,
  EngineeringOk = 4,
  CustomerDataAdded = 5,
  RegulationsRequestUpdated = 6,
  RegulationsOpenIssue = 7,
  RegulationsOk = 8,
  RequestApproved = 14,
  RequestDenied = 15,
  RequestWithdrawn = 16,
}
